import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Card, CardHeader, CardBody, Row, Col, FormGroup, Label, Input, Button, Table } from "reactstrap";
import axios from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MetaCampaigns = () => {
  const history = useHistory();
  const { token: authToken } = useSelector((state) => state.auth);
  const [adAccounts, setAdAccounts] = useState([]);
  const [selectedAccountId, setSelectedAccountId] = useState("");
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);

  const headers = () => ({ Authorization: `Bearer ${authToken}` });

  useEffect(() => {
    if (!authToken) return;
    axios
      .get("/ad-accounts", { headers: headers() })
      .then((res) => {
        const list = res.data.data || [];
        setAdAccounts(list);
        if (list.length > 0) setSelectedAccountId(list[0].id);
      })
      .catch(() => setAdAccounts([]));
  }, [authToken]);

  const loadCampaigns = () => {
    if (!selectedAccountId) return;
    setLoading(true);
    axios
      .get(`/ad-accounts/${selectedAccountId}/campaigns`, { headers: headers() })
      .then((res) => setCampaigns(res.data.data || []))
      .catch((e) => toast.error(e.response?.data?.message || "Failed to load campaigns"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (!selectedAccountId) return;
    loadCampaigns();
  }, [selectedAccountId]);

  return (
    <div className="animated fadeIn">
      <ToastContainer autoClose={5000} />
      <Row>
        <Col>
          <Card>
            <CardHeader className="d-flex justify-content-between align-items-center">
              <b>Meta Campaigns</b>
              <div>
                <Button color="secondary" size="sm" onClick={loadCampaigns} disabled={loading || !selectedAccountId}>
                  {loading ? "Refreshing..." : "Refresh"}
                </Button>
              </div>
            </CardHeader>
            <CardBody>
              <FormGroup>
                <Label>Ad account</Label>
                <Input
                  type="select"
                  value={selectedAccountId}
                  onChange={(e) => setSelectedAccountId(e.target.value)}
                >
                  {adAccounts.map((a) => (
                    <option key={a.id} value={a.id}>
                      {a.accountName || a.accountId}
                    </option>
                  ))}
                </Input>
              </FormGroup>

              <Table bordered striped responsive size="sm">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Objective</th>
                    <th>Status</th>
                    <th>Created</th>
                    <th>ID</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={6} className="py-4 text-center">
                        <i className="fas fa-spinner fa-pulse fa-2x" aria-hidden />
                      </td>
                    </tr>
                  ) : campaigns.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="py-4 text-center text-muted">
                        No campaigns found.
                      </td>
                    </tr>
                  ) : (
                    campaigns.map((c) => (
                      <tr key={c.id}>
                        <td>{c.name}</td>
                        <td>{c.objective}</td>
                        <td>{c.status}</td>
                        <td>{c.created_time ? new Date(c.created_time).toLocaleString() : "-"}</td>
                        <td style={{ fontFamily: "monospace" }}>{c.id}</td>
                        <td>
                          <Button
                            size="sm"
                            color="info"
                            onClick={() =>
                              history.push(`/seller/social-advertisement/campaign/${selectedAccountId}/${c.id}`)
                            }
                          >
                            View
                          </Button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default MetaCampaigns;
